var map = {
	"./Accomplishment.png": 1656,
	"./Avatar.png": 1657,
	"./AvatarSmall.png": 1099,
	"./Calendar-VGL-icon.png": 817,
	"./CollapseFilled.png": 1094,
	"./Concern.png": 1658,
	"./D6D664D85FEAAD31.png": 1659,
	"./D6D664D85FEAAD32.png": 1660,
	"./GlobalGivingCausesThumb.png": 1225,
	"./Mistake.png": 1661,
	"./NoConcern.png": 1662,
	"./TablePlaceholder.png": 394,
	"./appointments.png": 1663,
	"./biopic.png": 1242,
	"./calendar.png": 1664,
	"./class-duration-icon.png": 1665,
	"./classes.png": 1666,
	"./clients.png": 1667,
	"./dashboard.png": 96,
	"./event-calendar.png": 1098,
	"./excel-icon.png": 1668,
	"./gold-icon.png": 1669,
	"./logo-inner.png": 1670,
	"./logo-watermark.png": 1671,
	"./logo.png": 1672,
	"./mobile-code.png": 1243,
	"./navtest-icon-active.png": 1673,
	"./navtest-icon.png": 1674,
	"./patient-based-icon.png": 1675,
	"./personal.png": 1676,
	"./platinum-icon.png": 1677,
	"./rectangledot-icon-disable.png": 1678,
	"./rectangledot-icon.png": 1679,
	"./reports.png": 1680,
	"./rowimg02.png": 1681,
	"./sales.png": 1682,
	"./silver-icon.png": 1683,
	"./speciality.png": 1684,
	"./staff.png": 1100,
	"./summerPolicy.png": 1685,
	"./testicon.png": 1686,
	"./vector-cover-image.png": 1687,
	"./vectorglobal.png": 1244,
	"./vectorgloballogo.png": 1688,
	"./vg-logo.png": 903,
	"./vgl-blank-image.png": 440
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1241;